import { DataGridPro } from '@mui/x-data-grid-pro';
import { useBoundStore } from 'useStore';
import DetailPanel from '../DetailPanel/DetailPanel';
import {
	columns,
	getColumnGroups,
	getDetailPanelHeight,
	getRowHeight,
	getRowId,
	gridStyles,
	rowsPerPageOptions,
	slots,
} from './utils';

const getDetailPanelContent = (params) => <DetailPanel row={params.row} />;

export default function GeneralTable({ data, count, loading }) {
	const paginationModel = useBoundStore((state) => state.fgPaginationModel);
	const year = useBoundStore((state) => state.fgSelectedYear);
	const setPaginationModel = useBoundStore(
		(state) => state.setFgPaginationModel
	);

	const columnGroups = getColumnGroups(year);

	return (
		<DataGridPro
			loading={loading}
			rows={data}
			rowCount={count}
			getRowId={getRowId}
			columns={columns}
			columnGroupingModel={columnGroups}
			pageSize={25}
			getDetailPanelContent={getDetailPanelContent}
			getDetailPanelHeight={getDetailPanelHeight}
			getRowHeight={getRowHeight}
			disableColumnMenu
			pagination
			paginationMode="server"
			paginationModel={paginationModel}
			onPaginationModelChange={setPaginationModel}
			pageSizeOptions={rowsPerPageOptions}
			disableRowSelectionOnClick
			disableColumnReorder
			slots={slots}
			sx={gridStyles}
		/>
	);
}
